import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Link} from 'shells/link/link';

import styles from './quotas-no-teams-banner.module.css';

export function QuotasNoTeamsBanner() {
    return (
        <FlashBanner type='info' hasBorder={true} noRightPadding={true} animate={false}>
            <div className='full-width flex justify-sb'>
                <div>
                    Sales quotas are team-based – head over to your users and teams page to
                    configure teams before adding a quota.
                </div>
                <div className={styles['flash-banner-cta-container']}>
                    <Link variant='primary' href='/setup/user'>
                        Go to users and teams
                    </Link>
                </div>
            </div>
        </FlashBanner>
    );
}
